import { Component, OnInit,EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.css']
})
export class EditComponent implements OnInit {
@Output() editfn = new EventEmitter
  constructor() { }

  ngOnInit() {
  }

}
